export default __webpack_public_path__ + "static/media/stop.2a88f0f6.svg";